<template>
<div class="chapter">
<div class="inner_page">
<p><a id="toc"></a></p>
<div class="fmh1">Table of Contents</div>
<div> <br/></div>
<div class="cfmh"><a href="#/davi_9781571318398_oeb_als_r1">Also by David Gessner</a></div>
<div class="cfmh"><span href="#/davi_9781571318398_oeb_tp_r1" title="Link target outside of Sample">Title Page</span></div>
<div class="cfmh"><a href="#/davi_9781571318398_oeb_ded_r1">Dedication</a></div>
<div class="cfmh"><a href="#/davi_9781571318398_oeb_epi_r1">Epigraph</a></div>
<div class="cfmh"><a href="#/davi_9781571318398_oeb_fm1_r1">PRELUDE: INTO THE GULF</a></div>
<div> <br/></div>
<div class="cpt"><a href="#/davi_9781571318398_oeb_p01_r1"> In the Thick of It</a></div>
<div class="cct"><a href="#/davi_9781571318398_oeb_c01_r1">THE GREEN SUN RISES: JULY 16, 2010</a></div>
<div class="cct"><a href="#/davi_9781571318398_oeb_c02_r1">FORCES OF NATURE</a></div>
<div> <br/></div>
<div class="cpt"><span href="#/davi_9781571318398_oeb_p02_r1" title="Link target outside of Sample"> My Crowded Day</span></div>
<div class="cct"><span href="#/davi_9781571318398_oeb_c03_r1" title="Link target outside of Sample">UP IN THE AIR</span></div>
<div class="cct"><span href="#/davi_9781571318398_oeb_c04_r1" title="Link target outside of Sample">THE CASE AGAINST STRAIGHT LINES</span></div>
<div class="cct"><span href="#/davi_9781571318398_oeb_c05_r1" title="Link target outside of Sample">RUSSIAN DOLLS</span></div>
<div class="cct"><span href="#/davi_9781571318398_oeb_c06_r1" title="Link target outside of Sample">BEYOND FLIPPER</span></div>
<div class="cct"><span href="#/davi_9781571318398_oeb_c07_r1" title="Link target outside of Sample">A NIGHT AT THE FISH CAMP</span></div>
<div> <br/></div>
<div class="cpt"><span href="#/davi_9781571318398_oeb_p03_r1" title="Link target outside of Sample"> “Firm Ground Is Not Available Ground”</span></div>
<div class="cct"><span href="#/davi_9781571318398_oeb_c08_r1" title="Link target outside of Sample">BARRIERS</span></div>
<div class="cct"><span href="#/davi_9781571318398_oeb_c09_r1" title="Link target outside of Sample">STRESS BALLS</span></div>
<div class="cct"><span href="#/davi_9781571318398_oeb_c10_r1" title="Link target outside of Sample">THE OILED PELICAN</span></div>
<div class="cct"><span href="#/davi_9781571318398_oeb_c11_r1" title="Link target outside of Sample">ATLANTIS</span></div>
<div> <br/></div>
<div class="cpt"><span href="#/davi_9781571318398_oeb_p04_r1" title="Link target outside of Sample"> Beyond the Oiled Pelican</span></div>
<div class="cct"><span href="#/davi_9781571318398_oeb_c12_r1" title="Link target outside of Sample">MIGRATIONS</span></div>
<div class="cct"><span href="#/davi_9781571318398_oeb_c13_r1" title="Link target outside of Sample">DÉJÀ VU: A NORTHERN INTERLUDE</span></div>
<div> <br/></div>
<div class="cpt"><span href="#/davi_9781571318398_oeb_p05_r1" title="Link target outside of Sample"> Return</span></div>
<div class="cct"><span href="#/davi_9781571318398_oeb_c14_r1" title="Link target outside of Sample">TWO STORIES</span></div>
<div class="cct"><span href="#/davi_9781571318398_oeb_c15_r1" title="Link target outside of Sample">FAITH</span></div>
<div class="cct"><span href="#/davi_9781571318398_oeb_c16_r1" title="Link target outside of Sample">ENERGY</span></div>
<div class="cct"><span href="#/davi_9781571318398_oeb_c17_r1" title="Link target outside of Sample">ADAPTATION</span></div>
<div> <br/></div>
<div class="cbmh"><span href="#/davi_9781571318398_oeb_nts_r1" title="Link target outside of Sample">NOTES</span></div>
<div class="cbmh"><span href="#/davi_9781571318398_oeb_ack_r1" title="Link target outside of Sample">Acknowledgments</span></div>
<div class="cbmh"><span href="#/davi_9781571318398_oeb_bm3_r1" title="Link target outside of Sample">MILKWEED EDITIONS</span></div>
<div class="cbmh"><span href="#/davi_9781571318398_oeb_cop_r1" title="Link target outside of Sample">Copyright Page</span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// davi_9781571318398_oeb_toc_r1.vue?261033f2